"use client";
import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    (<Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:border-border group-[.toaster]:shadow-lg font-medium !text-slate-700 dark:!text-slate-200 [&_*]:!text-slate-700 dark:[&_*]:!text-slate-200",
          success: "font-semibold !text-slate-700 dark:!text-slate-200",
          error: "font-semibold !text-slate-700 dark:!text-slate-200",
          info: "font-medium !text-slate-700 dark:!text-slate-200",
          warning: "font-semibold !text-slate-700 dark:!text-slate-200",
          description: "!text-slate-600 dark:!text-slate-300",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground font-medium",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground font-medium",
        },
        style: {
          // Better font rendering for Windows
          WebkitFontSmoothing: 'antialiased',
          MozOsxFontSmoothing: 'grayscale',
          textRendering: 'optimizeLegibility',
        },
      }}
      {...props} />)
  );
}

export { Toaster }
